<template>
  <div class="talk-index">
    <div class="list">
      <div class="a">
        <img :src="miXinGetImgUrl(list.url) || defaultAvatar" alt="" />
        <div class="b">
          <p style="margin-left: 10px">{{ list.nickName }}</p>
          <p style="margin-left: 10px">{{ list.remark }}</p>
        </div>
      </div>

      <span @click="endServe">结束服务</span>
    </div>

    <div class="liaotiao" id="talkdiv">
      <van-pull-refresh
        class="refresh"
        v-model="refreshing"
        @refresh="onRefresh"
        id="indes" :style="getContentHeight"
      >
        <div class="a">文明沟通，共建良好沟通环境！</div>
        <div v-for="(item, index) in chatList" :key="index">
          <div :class="item.sendId != userider ? 'c' : 'd'">
            <div class="items">
              <div>
                <p v-if="item.type != '5'">{{ item.data }}</p>
                <div>
                  <img
                    style="
                      width: 50px;
                      height: 50px;
                      border-radius: 5px;
                      object-fit: cover;
                    "
                    v-if="item.type == '1'"
                    @click="imagePreview(item.content)"
                    :src="item.content"
                    alt=""
                  />
                  <div class="room-contact" v-if="item.type == '2' || item.type == '3'" :style="{borderRadius: (item.sendId != userider ? '0 8px 8px 8px' : '8px 0 8px 8px')}">
                    <div style="width: 80%;">
                      <p>{{ item.content }}</p>
                      <h5>房间号:&nbsp;{{ item.room ? item.room : '--' }}</h5>
                    </div>
                    <span @click="item.type == '2' ? vioceContact(item) : videoContact(item)">进入</span>
                  </div>
                  <p v-if="item.type == '0'" :style="{borderRadius: (item.sendId != userider ? '0 8px 8px 8px' : '8px 0 8px 8px')}">
                    {{ item.content }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.type == '4'" class="dang">
            <div class="ds">
              <div v-if="item.content == '2' || item.content == '3' || item.content == '4'" class="lefts">
                <div style="font-size: 15px; color: #333; margin-bottom: 5px; font-weight: bold;">
                  我请求查看您的心理档案
                </div>
                <div style="color: #999; font-size: 12px;">*请注意保护隐私</div>
              </div>
              <div class="rights">
                <div v-if="item.content == '2'" style="display: flex; align-items: center; justify-content: space-between;">
                  <p style="color: red; font-size: 15px;" @click="viewHandle('refuse')">拒绝</p>
                  <p style="color: #007aff; font-size: 15px;" @click="viewHandle('agree')">允许</p>
                </div>
                <p v-if="item.content == '3'" style="color: #999; font-size: 15px;">已同意</p>
                <p v-if="item.content == '4'" style="color: #999; font-size: 15px;">已拒绝</p>
              </div>
            </div>
            <div v-if="item.content == '1' || item.content == '3'" class="a" style="color: #007AFF; margin-top: 10px; font-size: 15px;">
              已{{ item.content == '1' ? '' : '允许' }}向对方公开心理档案
            </div>
            <div v-if="item.content == '4'" class="a" style="color: #ff1b1b; margin-top: 10px; font-size: 15px;">
              已拒绝向对方公开心理档案
            </div>
          </div>
        </div>
        <div class="dd" v-if="isEnd">{{ `----- 咨询已结束 -----` }}</div>
      </van-pull-refresh>

      <van-dialog
        v-model="showRate"
        className="rate_dialog"
        :show-confirm-button="false"
      >
        <div class="pj">
          <div class="ljpj">
            <div class="ljpj_title" @click="add">请对我的服务进行评价</div>
            <p>
              是否解决问题
              <van-rate
                v-model="valuethree"
                :size="25"
                color="#FF9500"
                void-icon="star"
                void-color="#DADADA"
                class="rate_line"
              />
              <span>"{{ valuethree }}"</span>
            </p>
            <p>
              咨询响应速度
              <van-rate
                v-model="valueone"
                :size="25"
                color="#FF9500"
                void-icon="star"
                void-color="#DADADA"
                class="rate_line"
              />
              <span>"{{ valueone }}"</span>
            </p>
            <p class="more_margin">
              解答专业程度
              <van-rate
                v-model="valuetwo"
                :size="25"
                color="#FF9500"
                void-icon="star"
                void-color="#DADADA"
                class="rate_line"
              />
              <span>"{{ valuetwo }}"</span>
            </p>
            <div class="btn_box" @click="add">提交评分</div>
          </div>
        </div>
      </van-dialog>
    </div>

    <div class="listtt" ref="send">
      <div class="bottom">
        <img
          style="width: 2.3125rem; height: 2.3125rem"
          src="../../assets/add.png"
          alt=""
          @click="isEnd ? null : showlist()"
        />
        <div class="img">
          <input
            type="text"
            name=""
            v-model="message"
            @keyup.enter="send"
            :disabled="isEnd"
            placeholder="回复："
            ref="inputBox"
          />
          <img
            src="../../assets/Vector.png"
            alt=""
            @click="isEnd ? null : emle()"
          />
        </div>
        <img
          style="width: 1.6875rem; height: 1.6875rem"
          src="../../assets/Subtract.png"
          alt=""
          @click="isEnd ? null : send()"
        />
      </div>

      <div class="yc ycs" v-show="emole">
        <div class="expression">
          <span
            @click="addEmo(item.emoji)"
            v-for="(item, index) in emoList"
            :key="index"
          >
            {{ item.emoji }}
          </span>
        </div>
      </div>
      <div class="yc" v-show="show">
        <a>
          <van-uploader
            class="van-uploader"
            :after-read="afterRead"
            accept="image/png,image/jpg,image/jpeg"
            :max-count="1"
          >
            <img src="../../assets/pic.png" alt="" />
          </van-uploader>
          <p>发送图片</p>
        </a>
        <a @click="vioceContact">
          <img src="../../assets/audio.png" alt="" />
          <p>语音沟通</p>
        </a>
        <a @click="videoContact">
          <img src="../../assets/redio.png" alt="" />
          <p>视频沟通</p>
        </a>
        <a @click="sendUserInfo">
          <img src="../../assets/file.png" alt="" />
          <p>查看档案</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
let socket;
import {
  getDetails,
  emjoin,
  uploadImages,
  getUuid
} from "../../api/user";
import { getPhoneType } from "../../utils/phoneType";
import { Toast, ImagePreview } from "vant";
import axios from "axios";
export default {
  data() {
    return {
      showRate: false, //默认不显示服务评价弹窗
      vodeiShow: false,
      getContentHeight: {
        height: "",
      },
      jsonList: {
        pageNum: 1,
        pageSize: 100,
      },
      dangan: "0", //是否查看档案
      yinshiVodeo: "0", //查看是否查看音视频
      userphone: localStorage.getItem("userName"),
      hasMore: true, //默认有更多数据
      file: "",
      imageFile: "",
      nickName: "",
      valueone: 5, // 三个评分
      valuetwo: 5,
      valuethree: 5,
      bottomDistance: "",
      show: false,
      a: false,
      c: false,
      e: false,
      refreshing: false,
      type: 0, //0是文本,1是图片,2是语音,3是视频,4是档案
      list: {},
      id: "",
      emole: false,
      message: "",
      emoList: [], //表情包数据
      chatList: [], //聊天列表
      userider: localStorage.getItem("userId"),
      isFirst: true,
      isEnd: false,
      defaultAvatar: require('@/assets/portrait.png')
    };
  },
  created() {
    this.getHeight();
    window.addEventListener("resize", this.getHeight);
    this.initWebsocket();
    this.id = this.$route.query.id;
    this.getdata();
    this.onLoad();
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.inputBox.focus()
      setTimeout(() => {this.$refs.inputBox.blur()}, 17)
    })
  },

  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },

  methods: {
    // 结束咨询
    endServe() {
      let params = {
        to: this.$route.query.id,
        type: "5",
        sendId: window.localStorage.getItem("userId")
      };
      socket.send(JSON.stringify(params));
      
      this.showRate = this.isEnd = true
    },

    getHeight() {
      this.isBigScreen = getPhoneType();
      if (this.isBigScreen) {
        this.bottomDistance = 34 + 68;
      } else {
        this.bottomDistance = 68;
      }
      this.getContentHeight.height =
        window.innerHeight - 140 + "px";
    },

    viewHandle(types) {
      if (typeof WebSocket == "undefined") {
        
      } else {
        // 组装待发送的消息 json
        //  **发送消息时;格式为{"to": "发给谁的id", "content": "内容","type":"0"}0是文本,1是图片,2是语音,3是视频,4是档案**
        let params = {
          to: this.$route.query.id,
          content: types === 'refuse' ? '4' : '3',
          type: "4",
          data: new Date().toLocaleString(),
          sendId: window.localStorage.getItem("userId")
        };
        socket.send(JSON.stringify(params));
        this.chatList.push(params);
        this.scrollBottom();
      }
    },

    initWebsocket() {
      let _this = this;
      let id = window.localStorage.getItem("userId");

      if (typeof WebSocket == "undefined") {
        
      } else {
        let socketUrl = "wss://websocket.qdszgh.cn:8443/sockxsj/websocket/message/" + id;

        // let socketUrl =
        //   "ws://192.168.0.40:8080/websocket/message/" + id;
        if (socket != null) {
          socket.close();
          socket = null;
        }
        // 开启一个websocket服务
        socket = new WebSocket(socketUrl);
        //打开事件
        socket.onopen = function () {
          
        };
        //  浏览器端收消息，获得从服务端发送过来的文本消息
        socket.onmessage = function (msg) {
          let data = JSON.parse(msg.data); // 对收到的json数据进行解析， 类似这样的： {"users": [{"username": "zhang"},{ "username": "admin"}]}

          if (data.type == '5') _this.isEnd = true
          data.sendId = data.from;
          if(data.content) _this.chatList.push(data);
          
          _this.scrollBottom();
        };
        //关闭事件
        socket.onclose = function () {
          
        };
        //发生了错误事件
        socket.onerror = function () {
          
        };
      }
    },

    scrollBottom() {
      this.$nextTick(() => {
        let div = document.getElementById("indes");
        div.scrollTop = div.scrollHeight;
      });
    },

    //提交评分
    add() {
      this.showRate = true;
      let valueall = (this.valueone + this.valuetwo + this.valuethree) / 3;
      axios({
        url: "/api/system/work/",
        method: "put",
        data: {
          id: window.sessionStorage.getItem("idall"),
          score: valueall,
          isOpen: this.dangan,
          isView: this.yinshiVodeo,
        },
      }).then((res) => {
        Toast.success("提交成功");
        this.showRate = false;
        this.scrollBottom();
      });
    },
    //查看档案
    sendUserInfo() {
      let params = {
        to: this.$route.query.id,
        content: '1',
        type: "4",
        data: new Date().toLocaleString(),
        sendId: window.localStorage.getItem("userId")
      };

      socket.send(JSON.stringify(params));
      this.chatList.push(params);
      this.scrollBottom();
    },
    send() {
      if (this.message == "") {
        Toast.fail("内容不能为空");
        return;
      }
      if (typeof WebSocket == "undefined") {
        
      } else {
        // 组装待发送的消息 json
        //  **发送消息时;格式为{"to": "发给谁的id", "content": "内容","type":"0"}0是文本,1是图片,2是语音,3是视频,4是档案**
        let params = {
          to: this.$route.query.id,
          content: this.message,
          type: "0",
          data: new Date().toLocaleString(),
          nickName: this.nickName,
          avatar: this.list.avatar,
        };

        let paramsall = {
          data: new Date().toLocaleString(),
          to: this.$route.query.id,
          content: this.message,
          type: "0",
          contentType: "1",
          sendId: window.localStorage.getItem("userId"),
        };

        socket.send(JSON.stringify(params));
        this.chatList.push(paramsall);
        // 构建消息内容，本人消息
        // this.createContent(null, this.$route.query.id, this.message);
        this.message = "";
        this.scrollBottom();
      }
    },

    onLoad() {
      if (this.refreshing) {
        Toast("没有更多数据了");
        this.refreshing = false;
      }
      if (!this.hasMore) {
        //没有更多数据了
        this.loading = true; //关闭无限滚动
        this.finished = true;
        return false;
      }
      this.getHistoryChat();
    },

    onRefresh() {
      //清空列表数据
      this.finished = false;
      //重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    //查看聊天记录
    getHistoryChat() {
      this.loading = true;
      let idone = this.$route.query.id;
      let idTwo = this.userider;

      axios({
        url: `/api/system/chatrecord/chatList?pageNum=${this.jsonList.pageNum}&pageSize=${this.jsonList.pageSize}&idOne=${idone}&idTwo=${idTwo}`,
        method: "get",
      }).then((res) => {
        if (res.data.code == 200) {
          this.chatList.unshift(...res.data.rows.reverse())

          if (this.isFirst) {
            this.isFirst = false;
            this.scrollBottom();
          }

          this.loading = false; //开启无限滚动

          if (this.jsonList.pageNum * this.jsonList.pageSize >= res.data.total) {
            this.hasMore = false;
            return;
          }
          this.jsonList.pageNum ++;
          
          if (res.data.rows.length && res.data.rows[0].nickName) {
            this.nickName = res.data.rows[0].nickName;
          }
        }
      });
    },

    imagePreview(message) {
      ImagePreview([message]);
    },
    //发送图片
    async afterRead(file) {
      if (typeof WebSocket == "undefined") {
        
      } else {
        Toast.loading({
          duration: 0, // 持续展示 toast
          message: "发送中...",
          forbidClick: true,
        });
        // 组装待发送的消息 json
        //  **发送消息时;格式为{"to": "发给谁的iparamss d", "content": "内容","type":"0"}0是文本,1是图片,2是语音,3是视频,4是档案**
        let formData = new FormData();
        let data = new Date().toLocaleString();
        formData.append("file", file.file);
        uploadImages(formData).then((res) => {
          Toast.clear();
          let param = {
            content: res.data,
            data: data,
            to: this.$route.query.id,
            type: "1",
            sendId: window.localStorage.getItem("userId")
          };
          socket.send(JSON.stringify(param));
          this.chatList.push(param);
          this.showlist()
        });
        // 构建消息内容，本人消息
        // this.createContent(null, this.$route.query.id, this.message);
      }
    },

    //语音沟通
    vioceContact(item) {
      if (!item.room) {
        getUuid()
          .then(async (res) => {
            if (res.code == 200) {
              let params = {
                to: this.$route.query.id,
                // content: `${localStorage.getItem("nickName") || '用户'}邀请您进行语音沟通`,
                content: `用户邀请您进行语音沟通`,
                type: "2",
                data: new Date().toLocaleString(),
                room: res.data,
                sendId: window.localStorage.getItem("userId")
              };
              socket.send(JSON.stringify(params));
              this.chatList.push(params);
              this.$nextTick(() => {
                this.scrollBottom();
              })

              await this.goVoipRoom('voice', res.data, this.miXinGetImgUrl(this.list.avatar) || this.defaultAvatar, this.list.nickName)
            }
          })
          .catch(function (err) {
            Toast.clear();
          });
      } else {
        this.goVoipRoom('voice', item.room, this.miXinGetImgUrl(item.avatar) || this.defaultAvatar, this.list.nickName)
      }
    },
    //视频沟通
    videoContact(item) {
      if (!item.room) {
        getUuid()
          .then(async (res) => {
            if (res.code == 200) {
              let params = {
                to: this.$route.query.id,
                // content: `${localStorage.getItem("nickName") || '用户'}邀请您进行视频沟通`,
                content: '用户邀请您进行视频沟通',
                type: "3",
                data: new Date().toLocaleString(),
                room: res.data,
                sendId: window.localStorage.getItem("userId")
              };
              socket.send(JSON.stringify(params));
              this.chatList.push(params);
              this.$nextTick(() => {
                this.scrollBottom();
              })

              await this.goVoipRoom('video', res.data)
            }
          })
          .catch(function (err) {
            Toast.clear();
          });
      } else {
        this.goVoipRoom('video', item.room)
      }
    },
    // 跳转实时音视频房间
    goVoipRoom(voipType, roomIds, avatar, nickName) {
      let isMini = window.localStorage.getItem('isMini')
      let openUrl = voipType === 'voice' ? 
      `pages/index/index?platformType=App&voipType=voice&roomId=${roomIds}&avatar=${avatar}&nickName=${nickName}` : 
      `pages/index/index?platformType=App&voipType=video&roomId=${roomIds}`

      Toast.loading({
        duration: 0, // 持续展示 toast
        message: "正在前往...",
        forbidClick: true,
      });

      setTimeout(() => {
        Toast.clear();

        if (labor.isApp()) {
          labor.openWxapp("gh_1de52caedb52", openUrl)
        } else {
          if (isMini === 'isMini') {
            if (wx.miniProgram) {
              let newUrl = voipType === 'voice' ? 
              `/pages/room/room?roomId=${roomIds}&avatar=${avatar}&nickName=${nickName}` : 
              `/pages/videoRoom/videoRoom?roomId=${roomIds}`
              wx.miniProgram.navigateTo({
                url: newUrl
              })
            }
          } else {
            Toast.fail('请在齐鲁工惠App内打开')
          }
        } 
      }, 1000)
    },

    addEmo(item) {
      this.message += item;
    },

    //表情包弹出框
    async emle() {
      this.show = false;
      this.emole = !this.emole;
      setTimeout(() => {
        this.sendHeight = this.$refs.send.offsetHeight;
        this.getContentHeight.height =
          window.innerHeight - 60 - this.sendHeight + "px";
        this.scrollBottom();
      }, 500);
      const res = await emjoin();
      this.emoList = res.rows;
    },

    async getdata() {
      const res = await getDetails(this.id);
      this.list = res.data;
      this.scrollBottom();
    },
    showlist() {
      this.show = !this.show;
      this.emole = false;
      setTimeout(() => {
        this.sendHeight = this.$refs.send.offsetHeight;
        this.getContentHeight.height =
          window.innerHeight - 60 - this.sendHeight + "px";
        this.scrollBottom();
      }, 500);
    },
    gohomes() {
      this.$router.go(-1);
    }
  },
};
</script>

<style lang="scss" scoped>
.talk-index {
  max-height: 100vh;
  background: #f7f7f7;
  /deep/ .van-overlay {
    background-color: rgba(0,0,0,0.7)!important;
    backdrop-filter: blur(8px)!important;
  }
  /deep/ .van-dialog {
    border-radius: 8px!important;
  }
  .xia {
    width: 100%;
    height: 60px;
  }
  .ycs {
    .expression {
      display: flex;
      flex-wrap: wrap;
      overflow-y: scroll;
      span {
        font-size: 20px;
      }
    }
    .expression::-webkit-scrollbar {
      display: none;
    }
  }
  .listtt {
    width: 100%;
    position: fixed;
    bottom: 0;

    .bottom {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      background: #fff;
      padding: 5px 8px 30px 8px;
      .img {
        position: relative;
        img {
          position: absolute;
          right: 12px;
          top: 4px;
          width: 30px;
          height: 30px;
          padding: 2px;
        }

        input::placeholder {
          color: #d0d0d0;
          font-size: 13px;
        }
        input {
          padding: 10px;
          width: 269px;
          height: 37px;
          border: 0;
          background: #F4F4F4;
          border-radius: 56px 56px 56px 56px;
        }
      }
    }
    .yc {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      background: #f9f9f9;
      padding: 10px 10px 20px;
      a {
        width: 25%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        p {
          margin-top: 0.625rem;
          color: #999999;
          font-size: 0.8125rem;
        }
        img {
          width: 57px;
          height: 57px;
          background: #fff;
          padding: 8px;
          border-radius: 9px;
        }
      }
    }
  }
  .pj {
    .ljpj {
      padding: 11px 22px 0 12px;

      .ljpj_title {
        font-size: 15px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
      }

      p {
        font-size: 14px;
        color: #666;
        display: flex;
        align-items: center;
        margin-bottom: 14px;
      }

      p.more_margin {
        margin-bottom: 23px;
      }

      .rate_line {
        margin: 0 18px;
      }
        
      .btn_box {
        border-top: 1px solid #F7F7F7;
        padding: 10px 0 15px;
        width: 100%;
        text-align: center;
        font-size: 15px;
        color: #007AFF;
      }
    }
  }

  .dd {
    font-family: PingFang SC-中等, PingFang SC;
    text-align: center;
    margin: 30px 0 0 0;
    padding-bottom: 30px;
    color: #999;
    font-size: 14px;
    font-weight: bold;
  }
  .liaotiao {
    .dang {
      p {
        margin-left: 10px;
        color: #333333;
        font-size: 15px;
      }
      .ds {
        margin-left: 12px;
        margin-top: 10px;
        display: flex;
        width: calc(80% - 20px);
        background: #ffffff;
        border-radius: 0px 8px 8px 8px;
        opacity: 1;
        display: flex;
        padding: 10px;

        .rights {
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
        }
        .lefts {
          width: 67%;
          height: 100%;
        }
      }
    }

    height: calc(100vh - 124px);
    overflow-y: auto;
    padding-bottom: 10px;
    .yc {
      width: 100%;
      height: 9.375rem;

      background: #f9f9f9;
      opacity: 1;
      display: flex;
      align-items: center;
      justify-content: space-around;
      justify-content: center;
      a {
        width: 25%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        p {
          margin-top: 0.625rem;
          color: #999999;
          font-size: 0.8125rem;
        }
        img {
          width: 2.5rem;
          height: 2.5rem;
        }
      }
    }
    .f {
      margin-left: 6.25rem;
      margin-top: 1.25rem;
      span {
        color: #999999;
        font-size: 0.75rem;
        margin-left: 13.75rem;
        margin-bottom: 0.625rem;
        display: inline-block;
      }
      .item {
        width: 16.5rem;
        height: 5.3125rem;
        background: #ffffff;
        border-radius: 0rem 0.5rem 0.5rem 0.5rem;
        opacity: 1;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
    }

    .e {
      width: 15.25rem;
      height: 1.125rem;
      font-size: 0.75rem;
      font-family: PingFang SC-常规, PingFang SC;
      font-weight: normal;
      color: #ff1b1b;
      line-height: 1.125rem;
      margin: auto;
      margin-top: 0.625rem;
    }

    .d, .c {
      margin-top: 20px;
      margin-left: 8px;

      p {
        color: #333333;
        font-size: 15px;
        margin-bottom: 0.625rem;
      }
      p:last-child, .room-contact {
        background: #ffffff;
        border-radius: 0 8px 8px 8px;
        padding: 9px 12px 10px 9px;
        word-break: break-all;
      }
      .items, .room-contact {
        display: flex;
        justify-content: flex-start;
      }

      .items {
        max-width: 80%;
      }

      .room-contact {
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
          color: #007AFF;
        }

        h5 {
          font-size: 16px;
        }
      }
    }
    .d {
      margin-right: 10px;
      display: flex;
      justify-content: flex-end;

      p:last-child, .room-contact {
        background: #cfe6ff;
      }

      .items {
        justify-content: flex-end;
      }
    }
    .a {
      padding-top: 0.1rem;
      font-size: 0.75rem;
      font-family: PingFang SC-常规, PingFang SC;
      font-weight: normal;
      text-align: center;
      color: #999;
    }
    .b {
      margin-left: 0.625rem;
      p {
        color: #999999;
        font-size: 0.75rem;
        margin-left: 0.625rem;
      }
      .item {
        width: 16.5rem;
        height: 3.3125rem;
        background: #ffffff;
        border-radius: 0rem 0.5rem 0.5rem 0.5rem;
        opacity: 1;
        color: #333333;
        font-size: 0.8125rem;
        padding: 0.625rem;
        margin-top: 0.625rem;
      }
    }
  }
  .list {
    width: 100%;
    border-radius: 0rem 0rem 0rem 0rem;
    opacity: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px 8px 16px;
    background: #fff;
    span {
      background: #ff1b1b;
      border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
      color: #fff;
      font-size: 12px;
      text-align: center;
      flex-shrink: 0;
      padding: 6px 10px;
    }
    .a {
      display: flex;
      align-items: center;
      position: relative;
      width: 70%;
      img:first-child {
        width: 2.75rem;
        height: 2.75rem;
        border-radius: 50%;
      }
      img:last-child {
        width: 0.9375rem;
        height: 0.9375rem;
        display: flex;
        position: absolute;
        left: 1.8125rem;
        top: 1.8125rem;
      }
    }
    .b {
      display: flex;
      flex-direction: column;
      margin-right: 1.25rem;
      width: 90%;
      p:first-child {
        color: #333;
        font-size: 0.9rem;
        margin-top: 0.3125rem;
        font-weight: bold;
      }
      p:last-child {
        color: #999;
        font-size: 0.8rem;
        margin-top: 0.3125rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .top {
    width: 100%;
    height: 3.125rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-weight: bold;
    .incon {
      margin-left: -2.5rem;
    }
  }
}

.refresh {
  overflow-y: scroll;
}

.refresh::-webkit-scrollbar {
  display: none;
}
</style>
